import { PageInfo } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'

export enum Themes {
  Primary = 'primary',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Purple = 'purple',
}

export enum Dates {
  Long = 'Do MMMM YYYY h:mma',
  Medium = 'dddd, MMMM Do YYYY',
  Short = 'DD MMM YYYY',
  ShortOrdinal = 'Do MMM YYYY',
  ShortReverse = 'MMM Do YYYY',
  ShortYear = 'YYYY-MM-DD',
  Time = 'h:mma',
  MonthYear = 'MMMM YYYY',
}

export type FilterTabItem = {
  key: string
  filterValue: string
  target?: string
  hidden?: boolean
}

export enum DocumentType {
  Requisition = 'Trade::Requisition',
  PurchaseOrder = 'Trade::PurchaseOrder',
  Invoice = 'Trade::Invoice',
  CreditNote = 'Trade::CreditNote',
}

export enum Env {
  Production = 'prd',
  Staging = 'stg',
  Development = 'dev',
  RC = 'rc',
}

export interface PaginatedTable {
  paginationLoading: boolean
  pageInfo: Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'endCursor'>
  onNextPage: () => void
  onPreviousPage: () => void
}

export type ButtonTheme = 'light' | 'dark'
